import React, {  useRef } from 'react'
import styl from "./WPSAU.module.css"
import { Swiper, SwiperSlide } from 'swiper/react';
import Icons from '../../../Assets/icons/Icons';
// import { lorem } from '../../../Constants/constant';
import UseResize from '../../Hooks/UseResize';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
// import Aos from 'aos';
import { PTag } from '../StyledTags/styledTags';

const WPSAU = ({style}) => {
  const cards = [
    {
      name: "Parent of a wonderful person we support",
      comment: "My daughter settled in better than I imagined. Her health has improved, she’s more independent, and our relationship is stronger than ever.",
    },
    {
      name: "Wonderful Person We Support",
      comment: "They communicate with me regularly; they are polite and very calm.",
    },
    {
      name: "Mother of a wonderful person we support",
      comment: "Professional, caring, and compassionate. They put my daughter’s needs first and fill her days with meaningful activities.",
    },
    {
      name: "Family of a wonderful person we support",
      comment: "They know our daughter’s needs and meet them with genuine care. She’s always happy, well presented, and communication is excellent.",
    },
    {
      name: "Wonderful Person We Support",
      comment: "I used to speak to my dad if I had a problem. Now he's not here, I'm grateful I have Lexrae.",
    },
    {
      name: "Parent of a wonderful person we support",
      comment: "Professional, compassionate, and focused on enhancing my son’s life. I’m confident he’s safe, valued, and well cared for.",
    },
  ]
  const { desktop } = UseResize()
  const swiperRef = useRef(null)
  // const [activeIndex, setActiveIndex] = useState(0)

  return (
    <section style={style} className={styl.wpsau}  >
      <h4>What people say about us</h4>
      <Swiper
        spaceBetween={30}
        slidesPerView={desktop ? 3 : 2}
        pagination={true}
        onSwiper={(swiper) => swiperRef.current = swiper}
        // onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
        className="wpsau_swiper"
        data-aos={"zoom-in"}
      >
        {cards.map((e, index)=>(
          <SwiperSlide key={index} className={styl.wpsau_card}>
            <span className={styl.quote}>{Icons.quotes}</span> 
            <PTag>{e.comment}</PTag>
            <h4 style={{ color: "#000", textAlign: "right", fontSize: "16px", margin: "0" }}>{e.name}</h4>
            <svg width="89" height="16" viewBox="0 0 89 16" fill="none" style={{ alignSelf: 'flex-start' }} xmlns="http://www.w3.org/2000/svg">
              <path d="M8.5 0L10.2961 5.52786H16.1085L11.4062 8.94427L13.2023 14.4721L8.5 11.0557L3.79772 14.4721L5.59383 8.94427L0.891548 5.52786H6.70389L8.5 0Z" fill="#F8E31A"/>
              <path d="M26.5 0L28.2961 5.52786H34.1085L29.4062 8.94427L31.2023 14.4721L26.5 11.0557L21.7977 14.4721L23.5938 8.94427L18.8915 5.52786H24.7039L26.5 0Z" fill="#F8E31A"/>
              <path d="M44.5 0L46.2961 5.52786H52.1085L47.4062 8.94427L49.2023 14.4721L44.5 11.0557L39.7977 14.4721L41.5938 8.94427L36.8915 5.52786H42.7039L44.5 0Z" fill="#F8E31A"/>
              <path d="M62.5 0L64.2961 5.52786H70.1085L65.4062 8.94427L67.2023 14.4721L62.5 11.0557L57.7977 14.4721L59.5938 8.94427L54.8915 5.52786H60.7039L62.5 0Z" fill="#F8E31A"/>
              <path d="M80.5 0L82.2961 5.52786H88.1085L83.4062 8.94427L85.2023 14.4721L80.5 11.0557L75.7977 14.4721L77.5938 8.94427L72.8915 5.52786H78.7039L80.5 0Z" fill="#DFE3EA"/>
            </svg>
          </SwiperSlide>
      ))}   
      </Swiper>
      <div className={styl.swiper_ctrl}>
        <button disabled={swiperRef.current?.isBeginning} onClick={()=>swiperRef?.current?.slidePrev()} >
          <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity={swiperRef.current?.isBeginning ? "0.4" : "1"}>
              <rect width="46" height="46" rx="23" fill="#F6F6F6"/>
              <path d="M29.5 23H16.5M16.5 23L23 29.5M16.5 23L23 16.5" stroke="#29AAE3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
          </svg>
        </button>
        <button disabled={swiperRef?.current?.isEnd} onClick={()=>swiperRef?.current?.slideNext()}>
          <svg width="46" height="46" viewBox="0 0 46 46" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g opacity={swiperRef?.current?.isEnd ? "0.4" : "1"}>
              <rect width="46" height="46" rx="23" fill="#F6F6F6"/>
              <path d="M16.5 23H29.5M29.5 23L23 29.5M29.5 23L23 16.5" stroke="#29AAE3" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </g>
          </svg>
        </button>
      </div>
  </section>
  )
}

export default WPSAU